import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatDate, truncateText } from '../utils/blogUtils';

function BlogCard({ post, readTime }) {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden hover:border-cyan-400 transition-colors h-full flex flex-col">
      {/* Featured Image */}
      <img
        src={post.featuredImage}
        alt={post.title}
        className="w-full h-48 object-cover"
      />

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow">
        {/* Date & Read Time */}
        <div className="flex items-center justify-between text-sm text-gray-400 mb-3">
          <span>{formatDate(post.date)}</span>
          <span>
            {readTime}
            {' '}
            min read
          </span>
        </div>

        {/* Title */}
        <Link to={`/blog/${post.slug}`}>
          <h2 className="text-xl font-bold text-cyan-400 mb-3 hover:text-cyan-300 transition-colors">
            {post.title}
          </h2>
        </Link>

        {/* Excerpt */}
        <p className="text-gray-300 mb-4 flex-grow">
          {truncateText(post.excerpt, 150)}
        </p>

        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          {post.tags.map((tag) => (
            <span
              key={tag}
              className="bg-gray-700 text-cyan-400 px-3 py-1 rounded-full text-sm border border-cyan-400/30"
            >
              {tag}
            </span>
          ))}
        </div>

        {/* Read More Button */}
        <Link
          to={`/blog/${post.slug}`}
          className="border-2 border-cyan-400 text-cyan-400 px-6 py-2 rounded-lg font-semibold hover:bg-cyan-400 hover:text-gray-900 transition-colors text-center inline-block"
        >
          Read More
        </Link>
      </div>
    </div>
  );
}

BlogCard.propTypes = {
  post: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    featuredImage: PropTypes.string.isRequired,
    excerpt: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  readTime: PropTypes.number.isRequired,
};

export default BlogCard;
